import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICartLineItem, ICustomCartLineItem, IProductItem } from '@care-portals/api-interfaces';

@Component({
  selector: 'portals-emr-order-products-popover',
  templateUrl: './order-products-popover.component.html',
  styleUrls: ['./order-products-popover.component.less'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class OrderProductsPopoverComponent implements OnInit, OnDestroy {
  @Input() items: (ICartLineItem | ICustomCartLineItem)[];

  constructor(
  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
  }

}
